(function () {
	'use strict';

	angular
		.module('expo-cupom-digital')
		.controller('OAuth2CallbackController', OAuth2CallbackController)

	/** @ngInject */
	function OAuth2CallbackController($location, $stateParams, $state, $httpParamSerializerJQLike, HelperService, UserService) {
		const vm = this;
		let returData;
		let provider;

		init();

		function loginWithFacebook() {
			HelperService.startLoading(".app-body", "Aguarde enquanto autenticamos seus dados");

			UserService
				.loginWithFacebook($httpParamSerializerJQLike(returData))
				.then(
					success => {
						HelperService.stopLoading(".app-body");

						if (success.errors) {
							HelperService.errorCallback(success);
							return
						}

						$state.go("app.home");
					}, error => {
						HelperService.stopLoading(".app-body");
						HelperService.errorCallback(error);
					});
		}

		function loginWithGoogle() {
			HelperService.startLoading(".app-body", "Aguarde enquanto autenticamos seus dados");

			console.log('returData: ', returData);
			UserService
				.loginWithGoogle($httpParamSerializerJQLike(returData))
				.then(
					success => {
						HelperService.stopLoading(".app-body");

						if (success.errors) {
							HelperService.errorCallback(success);
							return
						}

						$state.go("app.home");
					}, error => {
						HelperService.stopLoading(".app-body");
						HelperService.errorCallback(error);
					});
		}

		function init() {
			if ($stateParams.provider)
				provider = $stateParams.provider;

			if ($location.search())
				returData = $location.search();

			if (returData && provider) {
				if (provider == "facebook")
					loginWithFacebook();
				else if (provider == "google")
					loginWithGoogle();
				else
					$state.go("app.not-found");
			} else {
				$state.go("app.not-found");
			}
		}
	}
}());